module.exports = __webpack_public_path__ + "img/LR.2b40c813.svg";